import React from 'react';
import Text from '../Text/Text.js';
import Octicon from '../Octicon/Octicon.js';
import { AlertIcon } from '@primer/octicons-react';
import classes from './SelectPanel.module.css.js';
import { clsx } from 'clsx';

const SelectPanelMessage = ({
  variant,
  title,
  children,
  className
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(classes.Message, className)
  }, variant !== 'empty' ? /*#__PURE__*/React.createElement(Octicon, {
    icon: AlertIcon,
    className: classes.MessageIcon,
    "data-variant": variant
  }) : null, /*#__PURE__*/React.createElement(Text, {
    className: classes.MessageTitle
  }, title), /*#__PURE__*/React.createElement(Text, {
    className: classes.MessageBody
  }, children));
};
SelectPanelMessage.displayName = "SelectPanelMessage";

export { SelectPanelMessage };
